/*
  Snackbar compartido de Dolly Café.

  Se carga en todas las plantillas (incluida /cart, donde no se monta el
  panel lateral) para poder avisar de errores de carrito de forma visible,
  no solo con un texto para lectores de pantalla.
*/
(() => {
  const DURACION = 4500;
  let temporizador = null;

  const getRegion = () => {
    let region = document.querySelector('[data-dolly-snackbar-region]');
    if (region) return region;
    region = document.createElement('div');
    region.className = 'dolly-snackbar-region';
    region.setAttribute('data-dolly-snackbar-region', '');
    region.setAttribute('role', 'alert');
    region.setAttribute('aria-live', 'assertive');
    document.body.appendChild(region);
    return region;
  };

  const ocultar = (snackbar) => {
    snackbar.classList.remove('dolly-snackbar--visible');
    snackbar.addEventListener(
      'transitionend',
      () => snackbar.remove(),
      { once: true }
    );
    // Respaldo por si prefers-reduced-motion desactiva la transición.
    setTimeout(() => snackbar.remove(), 300);
  };

  const show = (mensaje, tipo = 'error') => {
    if (!mensaje) return;
    const region = getRegion();

    // Un solo aviso a la vez: pulsar +/- varias veces seguidas no debe
    // apilar toasts repetidos, solo reiniciar el tiempo de lectura.
    region.querySelectorAll('.dolly-snackbar').forEach((nodo) => nodo.remove());

    const snackbar = document.createElement('div');
    snackbar.className = `dolly-snackbar dolly-snackbar--${tipo}`;
    snackbar.textContent = mensaje;
    region.appendChild(snackbar);

    // Forzar reflow antes de agregar la clase que dispara la transición.
    void snackbar.offsetWidth;
    snackbar.classList.add('dolly-snackbar--visible');

    clearTimeout(temporizador);
    temporizador = setTimeout(() => ocultar(snackbar), DURACION);

    snackbar.addEventListener('click', () => {
      clearTimeout(temporizador);
      ocultar(snackbar);
    });
  };

  window.DollySnackbar = { show };
})();
